document.addEventListener('click',e=>{const b=e.target.closest('[data-bd-scroll]');if(!b)return;const row=document.getElementById(b.getAttribute('aria-controls'));if(row)row.scrollBy({left:Number(b.dataset.bdScroll)*row.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

// Keep carousel controls useful at either end, including after offer refreshes.
(() => {
  const bound = new WeakSet();
  const update = row => {
    const maximum = row.scrollWidth - row.clientWidth;
    document.querySelectorAll('[data-bd-scroll]').forEach(button => {
      if (button.getAttribute('aria-controls') !== row.id) return;
      button.disabled = maximum < 2 || (Number(button.dataset.bdScroll) < 0 ? row.scrollLeft <= 2 : row.scrollLeft >= maximum - 2);
    });
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));
  const init = () => document.querySelectorAll('[data-discovery-scroll],[data-discovery-rail],.bd-collection-carousel .list-collection>.row').forEach(row => {
    if (!bound.has(row)) {
      bound.add(row); row.addEventListener('scroll', () => update(row), {passive:true}); observer.observe(row);
      row.addEventListener('keydown', event => {
        if (event.target !== row || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); row.scrollBy({left:(event.key === 'ArrowLeft' ? -1 : 1)*row.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
    }
    update(row);
  });
  document.addEventListener('bd:rail-updated', () => requestAnimationFrame(init));
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
